import { getIntentLanguagesConstants } from '../constants'

const initialState = {}

export default (state = initialState, action = {}) => {
    const { slug } = action
    switch (action.type) {
        case getIntentLanguagesConstants.REQUEST:
            return {
                ...state,
                [slug]: {
                    ...(state[slug] || {}),
                    pending: true,
                },
            }
        case getIntentLanguagesConstants.SUCCESS: {
            const { response } = action

            return {
                ...state,
                [slug]: {
                    response,
                    pending: false,
                },
            }
        }
        case getIntentLanguagesConstants.FAILURE:
            return {
                ...state,
                [slug]: {
                    error: action.error,
                    pending: false,
                },
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/connectors/redux/reducers/intentLanguages.js